var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoistLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 32,
    viewBox: "0 0 105 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55549 31.9352C3.95954 31.9352 1.58343 30.3517 0 28.4702L3.20104 24.9075C4.52152 26.358 5.80593 27.22 7.42259 27.22C9.33828 27.22 10.5249 26.0656 10.5249 23.3933V8.5083H15.7385V23.6202C15.7385 29.2278 12.4406 31.9352 7.55549 31.9352Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5088 32.0001C26.3795 32.0001 21.2656 26.6878 21.2656 20.1224V20.056C21.2656 13.4906 26.4469 8.11377 33.5733 8.11377C40.7007 8.11377 45.8146 13.4261 45.8146 19.9905V20.056C45.8146 26.6232 40.6333 32.0001 33.5088 32.0001ZM40.5032 20.056C40.5032 16.0984 37.5983 12.7986 33.5087 12.7986C29.4182 12.7986 26.5798 16.031 26.5798 19.9914V20.056C26.5798 24.0155 29.4818 27.3144 33.5733 27.3144C37.6657 27.3144 40.5126 24.0829 40.5126 20.1224V20.056H40.5032Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3045 8.50195L56.3851 8.51714L56.3158 31.6108L51.2285 31.5966L51.3045 8.50195Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8368 31.9352C68.2285 31.9485 64.7408 30.6328 62.0391 28.2396L65.0398 24.6417C67.1197 26.3581 69.2965 27.4469 71.9355 27.4469C74.0154 27.4469 75.2666 26.6229 75.2666 25.2692V25.2037C75.2666 23.9174 74.4759 23.2558 70.617 22.2599C65.9635 21.0714 62.9627 19.7842 62.9627 15.1981V15.1421C62.9627 10.9509 66.3271 8.17896 71.0441 8.17896C74.4085 8.17896 77.281 9.22983 79.6239 11.1227L78.8578 12.2334L76.9849 14.9522C76.72 14.7681 76.4561 14.5943 76.1941 14.4311C74.4189 13.3261 72.676 12.6748 70.9786 12.6748C69.0335 12.6748 68.0092 13.5634 68.0092 14.6874V14.7519C68.0092 16.2708 69.0003 16.7663 72.9912 17.7897C77.676 19.0086 80.316 20.6926 80.316 24.7167V24.7832C80.316 29.3693 76.8187 31.9438 71.8368 31.9438",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6279 31.605H90.5539V13.1933H83.5195V8.50854H95.6003L95.6279 31.605Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.467 8.81821L97.6074 13.0236V8.49639L104.467 4.29004V8.81536",
    fill: "#8EC240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6074 0V4.52437L100.455 6.01477L103.889 3.84657L97.6074 0Z",
    fill: "#181818"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoistLogo);
export default __webpack_public_path__ + "static/media/joist_logo.729eee4dd0e6923bf499324986e8c263.svg";
export { ForwardRef as ReactComponent };